module.exports = __webpack_public_path__ + "static/media/netskope-logo-only.b7955f16.svg";